import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { OtpService } from '../otp/otp.service';
import { LocalStorageService } from '../storage/local-storage.service';
import { Router } from '@angular/router';

const ACCESS_TOKEN_KEY = 'access_token';
const REFRESH_TOKEN_KEY = 'refresh_token';
const EXPIRES_AT = 'expires_at';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private otpService: OtpService,
    private storage: LocalStorageService,
    private router: Router,
  ) {}

  isLoggedIn() {
    const token = this.getAccessToken();
    return token && token !== 'null' && token !== 'undefined';
  }

  getAccessToken() {
    return this.storage.get(ACCESS_TOKEN_KEY);
  }

  getRefreshToken() {
    return this.storage.get(REFRESH_TOKEN_KEY);
  }

  updateTokens({ access_token }) {
    this.storage.set(ACCESS_TOKEN_KEY, access_token);
    this.storage.set(REFRESH_TOKEN_KEY, access_token);
  }

  removeToken() {
    this.storage.remove(ACCESS_TOKEN_KEY);
    this.storage.remove(EXPIRES_AT);
    this.storage.remove(REFRESH_TOKEN_KEY);
  }

  refreshToken(refreshToken) {
    return of([]);
  }

  getAuthHeaders() {
    const token = this.getAccessToken();
    return {
      Authorization: `Bearer ${token}`,
    };
  }

  updateExpiry(expirtyAt) {
    this.storage.set(EXPIRES_AT, expirtyAt);
  }

  getExpiry() {
    return this.storage.get(EXPIRES_AT);
  }

  login(details): Observable<any> {
    return this.otpService.verifyOtp(details).pipe(
      tap((response: any) => {
        this.updateTokens(response.body);
        this.updateExpiry(response.body.expires_at);
      })
    );
  }

  deleteAccount(): Observable<any> {
    return this.otpService.deleteAccount().pipe(
      tap((response: any) => {
        console.log(response);
      })
    );
  }

  async logout() {
    this.removeToken();
    this.router.navigate(['/welcome'], { replaceUrl: true });
  }
}
